// extracted by mini-css-extract-plugin
export var infoRow = "_ve-2";
export var labelContainer = "_ve-0";
export var rightInfo = "_ve-1";